// extracted by mini-css-extract-plugin
export default {"ordersCard":"SingleForWarehouse_ordersCard__PM2Rd","orderRow":"SingleForWarehouse_orderRow__GyDrN"};